import axios from '@/utils/request'

/**
 * @description 用户列表
 */
export const getNoticeList = (data) => axios({
  url: 'notice',
  data
})

/**
 * @description 编辑通知
 */
export const updateNotice = (data) => axios({
  url: 'notice',
  method: 'put',
  data
})

/**
 * @description 删除通知
 */
export const deleteNotice = (uuid) => axios({
  url: `notice/${uuid}`,
  method: 'delete',
})
